import { type FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { ImageComponent } from '@/components/Image';
import { useOpenSans } from '@/modules/promo/hooks/useOpenSans';
import { COVERFLOW_SLIDER_VIP_ITEMS } from '../../helpers';
import { ScVIPCard, ScVIPItem } from './styled';

export const VIPCard: FC<{
  translation: string;
}> = ({ translation }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation(translation);

  useOpenSans();

  return (
    <ScVIPCard>
      <div className="content">
        {COVERFLOW_SLIDER_VIP_ITEMS.map((item) => (
          <ScVIPItem borderColor={item.borderColor} key={item.percentage}>
            <ImageComponent {...item.image} height={64} />
            <div className="vip-item__content">
              {Object.values(
                t(`vipCard.${item.content}`, {
                  returnObjects: true,
                })
              ).map((benefit, idx) => (
                <Fragment key={idx}>
                  <p className={`text ${language}`} key={idx}>
                    <span>{benefit as string}</span>
                    {idx ? (
                      <ImageComponent
                        alt="tick"
                        height={16}
                        src="/lp/dragon-pearls-november-25/tick.svg"
                        width={16}
                      />
                    ) : (
                      <span>{item.percentage}</span>
                    )}
                  </p>
                  <div className="divider" />
                </Fragment>
              ))}
            </div>
          </ScVIPItem>
        ))}
      </div>
    </ScVIPCard>
  );
};
